import React from "react";
import Blocker from "../../Misc/Blocker";
import Context from "../../../Context";
import CrumbsProvider from "../../Misc/CrumbsProvider";

import List from "../../Misc/List";
import FieldsList from "../../Misc/FieldsList";
import Sortings from "../../Misc/Sortings";
import Filters from "../../Misc/Filters";
import Searchbox from "../../Misc/Searchbox";

import DateRangePk from "../../Misc/DateRangePk";
import ManualChangedItem from "./ManualChangedItem";

export default class ManualChanged extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    let datefrom = new Date();
    let dateto = new Date();
    datefrom.setDate(datefrom.getDate() - 30);

    this.state = {
      pending: false,
      dateArgs: { datefrom, dateto },
      datePickerShow: false,

      sortings: {
        all: [
          {
            id: "byLabelAsc",
            active: false,
            title: "По алфавиту",
            value: ["label ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: [],
      },
    };
  }

  handleSortings = (chnagedSortings) => {
    this.setState((state) => {
      let sortings = state.sortings;
      sortings.active = chnagedSortings;
      return { sortings };
    });
  };

  onSearch = (text) => {
    let search = text
      ? [
          {
            lstr: "(",
            field: "label",
            compare: "IKE",
            value: `%${text}%`,
            rstr: ")",
          },
        ]
      : [];
    this.setState({ search });
  };

  onDateChange = (datefrom, dateto) => {
    this.setState({
      dateArgs: {
        datefrom,
        dateto,
      },
    });
  };

  onDatepickerClose = () => {
    this.setState({
      datePickerShow: false,
      customListKey: this.context.key(),
    });
  };

  onDatepickerOpen = () => {
    this.setState({
      datePickerShow: true,
    });
  };

  render() {
    return (
      <>
        <CrumbsProvider title="Изменения документации" />
        <div className="container">
          <div className="card card-custom  ">
            <div className="card-header px-5 py-2">
              <div className="card-title w-100 mr-0 p-lg-0 py-5 d-block d-lg-flex align-items-center justify-content-between">
                <div className="text-nowrap d-inline-block mr-2">
                  <Searchbox onSearch={this.onSearch} />
                </div>

                <div>
                  <button
                    className="btn btn-light mr-2"
                    onClick={this.onDatepickerOpen}
                  >
                    {this.state.dateArgs.datefrom.toLocaleDateString()} -{" "}
                    {this.state.dateArgs.dateto.toLocaleDateString()}
                  </button>
                  <DateRangePk
                    closeFn={this.onDatepickerClose}
                    changeFn={this.onDateChange}
                    show={this.state.datePickerShow}
                    startDate={this.state.dateArgs.datefrom}
                    endDate={this.state.dateArgs.dateto}
                  />

                  <Sortings
                    changeFn={this.handleSortings}
                    sortings={this.state.sortings.all}
                  />
                </div>
              </div>
            </div>
            <div className="card-body px-5">
              <List
                listKey="ManualChangedList"
                key={this.state.customListKey}
                fulltext={JSON.stringify(this.state.search)}
                sort={JSON.stringify(this.state.sortings.active)}
                limit={20}
                keyField="id"
                path="/manual/changed/list"
                customArgs={JSON.stringify(this.state.dateArgs)}
                row={this.state.viewGrid}
                onLoadStart={this.onListLoadStart}
                onLoadEnd={this.onListLoadEnd}
              >
                <ManualChangedItem />
              </List>
            </div>
          </div>
        </div>
      </>
    );
  }
}
